import { render, staticRenderFns } from "./trochaldisk-set.vue?vue&type=template&id=d4370d7a&scoped=true&"
import script from "./trochaldisk-set.vue?vue&type=script&lang=js&"
export * from "./trochaldisk-set.vue?vue&type=script&lang=js&"
import style0 from "./trochaldisk-set.vue?vue&type=style&index=0&id=d4370d7a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4370d7a",
  null
  
)

export default component.exports